var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconEmail = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "IconEmail",
  x: "0px",
  y: "0px",
  viewBox: "0 0 45.9 27.9",
  style: {
    enableBackground: "new 0 0 45.9 27.9"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0e{fill:none;stroke:#6fc9d1;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0e",
  d: "M42.3,1H23h0H3.6C3.6,1,1,1.3,1,3.4v10.4V14v10.4c0,2.2,2.6,2.4,2.6,2.4H23h0h19.3c0,0,2.6-0.3,2.6-2.4V14 v-0.1V3.4C44.9,1.3,42.3,1,42.3,1z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st0e",
  points: "1,5.5 23.1,18.6 44.9,5.5  "
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconEmail.2f6b4407.svg";
export { ForwardRef as ReactComponent };